<template>
  <div class="w-100 overflow-hidden" style=" height: 100vh;">
    <iframe src="https://script.google.com/a/macros/goethe.edu.ar/s/AKfycbyiYG4YFnklRBiVGgP_4ys0ceVw1ZnZNHRKKOaaZuK2hbkg6haaOjgTztH-wclEct9flA/exec" 
            width="100%"
            style="border: none; height: 100vh; margin: 0;">
    </iframe>
  </div>
</template>

<script>
import { onMounted, ref} from 'vue';
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useI18n } from 'vue-i18n';

export default {
  name: "InventarioPage",
  setup() {
    const { t } = useI18n();
    const message = ref('You are not logged in!');
    const imageUrl = ref(''); // For storing the image URL
    const store = useStore();
    const router = useRouter();

    const isTokenValid = () => {
      const token = localStorage.getItem('authToken')
      if (!token) return false;

      try {
        const [, payloadBase64] = token.split('.');
        const payload = JSON.parse(atob(payloadBase64));
        const currentTime = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
        console.log('currenttime:'+currentTime)
        console.log('payload:'+payload.exp)
        return payload.exp > currentTime; // Comparar el tiempo de expiración
      } catch (error) {
        console.error('Error al decodificar el token:', error);
        return false;
      }
    };

    onMounted(async () => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }

      if (isTokenValid()) {
        console.log('El token es válido.');
      } else {
        console.log('El token ha expirado.');
        const url = window.location.href; 
        const cleanedUrl = url.split("/#")[1];
        if(cleanedUrl!="/login"){
          localStorage.setItem('redirectAfterLogin', cleanedUrl);
        }
        store.dispatch('logOut');
        await router.push('/login');
      }
    })
    return {
      message,
      imageUrl,
      t,
    }
  }
}
</script>
<style scoped>
</style>